<!-- CART MODAL START -->
<!-- <app-navbar-cart #cartModal="cartModal"></app-navbar-cart> -->
<!-- CART MODAL END -->

<!-- PHONE MODAL START -->
<app-phone-modal #phoneModalView="phoneModal" [phoneNumber]='branding.cs_phone_number'></app-phone-modal>
<!-- PHONE MODAL END -->

<!--Double navigation-->
@if (!isWidget) {
  <header>
    <!-- Nav -->
    @if (isNavVisible) {
      <app-desktop-nav [logo]="logo" [navLinks]="navLinks" [productLinks]="productLinks" [isLogin]="isLogin" (showCart)="showCart()" (callbackSignOut)="clickAccountLogout()"></app-desktop-nav>
    }
    <!--/. Nav -->
  </header>
}
<div class="icon-bar">
  <div class="desktop">
    <a id="iconBarCallButton" class="call" role="button" tabindex="0" [attr.aria-label]="'NAV.CALL_US' | translate" (click)="phoneModalView.show()"><mdb-icon fas icon="phone"></mdb-icon></a>
  </div>
  <div class="mobile" >
    <a id="iconBarCallLink" href="tel:{{ branding.cs_phone_number }}" class="call" [attr.aria-label]="'NAV.CALL_US' | translate">
      <mdb-icon fas icon="phone"></mdb-icon>
    </a>
  </div>
</div>

<!--/.Double navigation-->
